"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultCommonConfig = exports.DefaultConsentPolicy = exports.BrandToHostMap = exports.DefaultBrand = exports.EventContextMap = exports.LoggerVersion = void 0;
exports.LoggerVersion = '2.0.875';
var EventContextMap;
(function (EventContextMap) {
    EventContextMap["msid"] = "_msid";
    EventContextMap["clientId"] = "_client_id";
    EventContextMap["uuid"] = "_uuid";
    EventContextMap["visitorId"] = "_visitorId";
    EventContextMap["siteMemberId"] = "_siteMemberId";
    EventContextMap["brandId"] = "_brandId";
})(EventContextMap = exports.EventContextMap || (exports.EventContextMap = {}));
exports.DefaultBrand = 'wix';
exports.BrandToHostMap = {
    wix: 'wix',
    editorx: 'editorx',
};
exports.DefaultConsentPolicy = {
    functional: true,
    analytics: true,
};
exports.DefaultCommonConfig = {
    brand: exports.DefaultBrand,
};
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/web-bi-logger/dist/src/constants.js
// module id = 36
// module chunks = 0 1